export default __webpack_public_path__ + "static/media/ad_5.4231af39.mp3";